import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

interface SeparatorProps {
  isCompleted?: boolean
}

const Dash = styled.div<SeparatorProps>`
  ${({
    theme: {
      colors: { strokeBrand, strokeWeak },
    },
    isCompleted,
  }) => css`
    width: 4px;
    height: 2px;
    background-color: ${isCompleted ? strokeBrand : strokeWeak};
  `}
`

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing2 },
    },
  }) => css`
    display: flex;
    flex-direction: row;
    gap: ${spacing2};
  `}
`

const Separator: FunctionComponent<SeparatorProps> = ({ isCompleted }) => (
  <StyledWrapper>
    <Dash isCompleted={isCompleted} />
    <Dash isCompleted={isCompleted} />
    <Dash isCompleted={isCompleted} />
  </StyledWrapper>
)

export default Separator
